import { QueryClient } from '@tanstack/react-query';

let browserQueryClient: QueryClient | null = null;

export function createQueryClient(): QueryClient {
    return new QueryClient({
        defaultOptions: {
            queries: {
                // Inactive navigation data is still removed immediately, but active
                // shared shell queries should not refetch once per mounted consumer.
                staleTime: 0,
                // Drop inactive queries immediately on unmount so that page navigation always reloads.
                gcTime: 0,
                refetchOnMount: false,
                refetchOnReconnect: 'always',
                // Window focus refetch is noisy; navigation/role-switch already covers correctness.
                refetchOnWindowFocus: false,
                retry: 1,
            },
        },
    });
}

export function getQueryClient(): QueryClient {
    if (!browserQueryClient) {
        browserQueryClient = createQueryClient();
    }

    return browserQueryClient;
}
